import { UserEditorState } from 'types/state';
import { createUserFormValues } from 'utils/createUserFormValues';

export const createUserEditorState = (): UserEditorState => ({
  formValues: createUserFormValues(),
  submitDidSucceed: false,
  submited: false
});
